<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-19 16:43:14
 * @LastEditTime: 2022-11-02 16:00:52
 * @Description: 记录关联结算单
 * @Param:
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\collectionRecord\recordAssociation.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="recordAssociation">
            <van-nav-bar
                title="关联结算单"
                left-text="收款记录"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <van-search
                    v-model="keywords"
                    placeholder="请输入搜索信息"
                    @search="search"
                ></van-search>
                <ul class="list" :class="{'noData': listData.length == 0}">
                    <template v-for="(item,index) in listData">
                        <li
                            :key="`list_${index}`"
                            :class="{'active': listIndex == index}"
                            @click="selectSettlementDocument(item, index)"
                        >
                            <div class="engineeringInfo">
                                <h4 class="engineeringInfo_header">
                                    <span class="headerName">结算单编号:{{ item.settlement_number }}</span>
                                </h4>
                                <div class="engineeringInfo_content">
                                    <div>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>结算周期：{{ item.settlement_start_time }}-{{ item.settlement_end_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                            <span>期数：{{ item.period_number }}</span>
                                        </p>
                                    </div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>期初按节点应收余额：{{ item.Initial_receivables }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>本期按节点应收余额：{{ item.loans_receivable }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>期末按节点应收余额：{{ item.ending_balance_receivable }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>本期实收余额：{{ item.official_receipt }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                        <span v-if="item.settlement_status == 1">状态：未对账</span>
                                        <span v-if="item.settlement_status == 2">状态：已对账</span>
                                        <span v-if="item.settlement_status == 3">状态：已收款</span>
                                    </p>
                                    <span class="state iconfont iconjiaobiao">
                                        <i class="iconfont iconduigou"></i>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
                <footer class="commonFormBtns" v-if="listData.length > 0">
                    <van-button
                        block
                        type="primary"
                        color="#E81B1B"
                        @click="determineAssociation"
                    >
                        确定
                    </van-button>
                </footer>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'record-association',
    components: {},
    props: {},
    data() {
        return {
            // 搜索关键词
            keywords: '',
            // 合同编号
            contract_number: '',
            // 收款编号
            proceeds_number: '',
            listData: [],
            listIndex: null,
            selectList: {},
            openType: '',
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.openType = this.$route.params.type;
        if (this.openType === 'addCollectionRecord') {
            this.contract_number = this.$route.params.contract_number;
        } else {
            this.contract_number = this.$route.params.row.contract_number;
            this.proceeds_number = this.$route.params.row.proceeds_number;
        }
        this.listData = await this.getListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        search() {},
        // 选择结算单
        selectSettlementDocument(res, index) {
            this.listIndex = index;
            this.selectList = res;
        },
        // 确定关联
        async determineAssociation() {
            let settlement_number = '';
            if (Object.keys(this.selectList).length > 0) {
                if (this.openType === 'addCollectionRecord') {
                    this.$router.isBack = 1;
                    this.$router.replace({
                        name: 'addCollectionRecord',
                        params: {
                            selectList: this.selectList,
                        },
                    });
                    this.$router.go(-1);
                } else {
                    settlement_number = this.selectList.settlement_number;
                    const requestCallback = await this.associationRequest(settlement_number);
                    if (requestCallback) {
                        this.$toast.success('关联成功');
                        this.$router.isBack = 1;
                        this.$router.replace({
                            name: 'collectionRecord',
                        });
                        this.$router.go(-1);
                    }
                }
            } else {
                this.$toast('请先选择结算单');
            }
        },

        // 获取结算单数据
        getListData() {
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/sale/accounts/proceeds/get_accounts_settlement_by_contract/${this.contract_number}`, { defEx: true });
        },

        // 关联请求
        associationRequest(settlement_number) {
            // eslint-disable-next-line max-len
            return this.$axios.$post(`/interfaceApi/sale/accounts/proceeds/rel_settlement/${this.proceeds_number}/${settlement_number}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.recordAssociation
    height 100%
    section
        height calc(100% - 44rpx)
        overflow: hidden;
        background: #f0f0f0;
        .list
            height calc(100% - 100rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            background: #f0f0f0;
            padding 15rpx
            padding-bottom 0
            &.noData
                height calc(100% - 40rpx)
                background url(../../../assets/images/common/no_data.png) center no-repeat
                background-size 100% auto
            li
                width 100%
                background #fff
                margin-bottom 15rpx
                &.active
                    .state
                        &:before
                            color #3495FB !important
                .engineeringInfo
                    position relative
                    padding 15rpx
                    img,span
                        float left
                        line-height 16rpx
                    span
                        width calc(100% - 33rpx)
                        overflow hidden
                        white-space nowrap
                        text-overflow ellipsis
                    img
                        width 16rpx
                        margin-right 12rpx
                    h4,p
                        overflow hidden
                    h4
                        margin-bottom 14rpx
                        img
                            width 20rpx
                            height auto
                            line-height 22rpx
                        span
                            font-size 18rpx
                            line-height 22rpx
                            color #061F3E
                            &:before
                                font-size 20rpx
                                margin-right 10rpx
                                color #3495FB
                    .engineeringInfo_content
                        >div
                            display flex
                            p
                                flex 1
                    p
                        margin-bottom 14rpx
                        &:last-child
                            margin-bottom 0
                        span
                            display inline-block
                            width calc(100% - 40rpx)
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            color #666666
                    .state
                        position absolute
                        top 0
                        right 0
                        font-weight 400
                        width 40rpx
                        height 40rpx
                        &:before
                            font-size 40rpx
                            line-height 40rpx
                            color #D7D7D7
                            position absolute
                            top 0px
                            right 0
                        i
                            position absolute
                            width 40rpx
                            text-align center
                            font-size 16rpx
                            color #FFFFFF
                            top 5rpx
                            left 9rpx
        .commonFormBtns
            height 60rpx
            padding 10rpx
            text-align right
            background #FFFFFF
            box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)
            button
                width 100rpx
                height 40rpx
                margin-left: 10rpx
                display: inline-block
</style>